import { Alert } from 'doctornow-design-system';
import usePhoneVerificationViewModel from '../hooks/usePhoneVerificationViewModel';

const NICE_CERTIFICATION_SERVICE_URL = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
const PhoneVerificationView = () => {
  const { requestEncodeData, isLoading, certificationAlertOpen, onCloseCertificationPopup } =
    usePhoneVerificationViewModel();

  if (isLoading) {
    return (
      <div className='flex min-h-screen items-center justify-center bg-gray-50'>
        <div className='text-center'>
          <div className='mx-auto mb-[16px] h-[32px] w-[32px] animate-spin rounded-full border-blue-600 border-b-2'></div>
          <p className='text-gray-600'>본인인증을 준비하고 있습니다...</p>
        </div>
      </div>
    );
  }

  return (
    <div className='min-h-screen bg-gray-50'>
      <form id='niceForm' name='form_chk' method='post' action={NICE_CERTIFICATION_SERVICE_URL} target='_self'>
        <input type='hidden' name='m' value='checkplusService' />
        <input type='hidden' name='EncodeData' value={requestEncodeData || ''} />
        <input type='hidden' name='recvMethodType' value='get' />
      </form>
      <Alert
        type='single'
        title='본인인증 실패'
        description='본인인증에 실패했습니다. 다시 시도해주세요.'
        open={certificationAlertOpen}
        onOpenChange={onCloseCertificationPopup}
        buttons={[
          {
            label: '확인',
            onClick: onCloseCertificationPopup,
          },
        ]}
      />
    </div>
  );
};

export default PhoneVerificationView;
